// Enum to match backend AutismDiagnosisStatus
export enum AutismDiagnosisStatus {
  YES = 'YES',
  NO = 'NO',
  IN_PROCESS = 'IN_PROCESS',
}

// Enum to match backend GetSignedUrlUploadType
export enum GetSignedUrlUploadType {
  USER_PROFILE = "USER_PROFILE",
  INSURANCE = "INSURANCE",
  MESSAGES = "MESSAGES",
  DOCUMENTS = "DOCUMENTS",
  BULLETIN = "BULLETIN",
  RESUME = "RESUME",
  CDE = "CDE",
  FEEDBACK = "FEEDBACK",
  BLOG_WRITER = "BLOG_WRITER",
  BLOG = "BLOG",
  LMN = "LMN",
}

export interface DiagnosticProviderInfo {
  providerGroup?: string;
  providerName?: string;
  providerPhone?: string;
}

export interface DiagnosticInfoDto {
  autismDiagnosis?: AutismDiagnosisStatus;
  cdeUrl?: string;
  lmnUrl?: string;
  diagnosticProviderInfo?: DiagnosticProviderInfo;
  letterProviderInfo?: DiagnosticProviderInfo;
} 